/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    InternalApiDocument,
    InternalApiDocumentFromJSON,
    InternalApiDocumentToJSON,
    InternalApiUniversalDocumentEntityType,
    InternalApiUniversalDocumentEntityTypeFromJSON,
    InternalApiUniversalDocumentEntityTypeToJSON,
    InternalApiUniversalDocumentsList,
    InternalApiUniversalDocumentsListFromJSON,
    InternalApiUniversalDocumentsListToJSON,
    InternalDocumentsPage,
    InternalDocumentsPageFromJSON,
    InternalDocumentsPageToJSON,
} from '../models';

export interface DeleteUniversalDocumentRequest {
    documentId: number;
}

export interface DownloadAllUniversalDocumentsRequest {
    entityType: InternalApiUniversalDocumentEntityType;
    entityId?: number;
    entityRef?: string;
}

export interface DownloadAllUniversalDocumentsResponse {
    headers: Headers;
    body: Blob;
}

export interface DownloadUniversalDocumentRequest {
    documentId: number;
}

export interface DownloadUniversalDocumentResponse {
    headers: Headers;
    body: Blob;
}

export interface FindDocumentsRequest {
    entityTypes: Array<InternalApiUniversalDocumentEntityType>;
    entityIds?: Array<number>;
    entityRefs?: Array<string>;
}

export interface SearchDocumentsRequest {
    entityType: InternalApiUniversalDocumentEntityType;
    page: number;
    size: number;
    entityId?: number;
    entityRef?: string;
    query?: string;
}

export interface UploadDocumentsRequest {
    entityType: string;
    file: Blob;
    entityId?: number;
    entityRef?: string;
}

/**
 * 
 */
export class UniversalDocumentsApi extends runtime.BaseAPI {

    /**
     * Archive document
     */
    async deleteUniversalDocumentRaw(requestParameters: DeleteUniversalDocumentRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.documentId === null || requestParameters.documentId === undefined) {
            throw new runtime.RequiredError('documentId','Required parameter requestParameters.documentId was null or undefined when calling deleteUniversalDocument.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/documents/{documentId}`.replace(`{${"documentId"}}`, encodeURIComponent(String(requestParameters.documentId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Archive document
     */
    async deleteUniversalDocument(requestParameters: DeleteUniversalDocumentRequest, initOverrides?: RequestInit): Promise<void> {
        await this.deleteUniversalDocumentRaw(requestParameters, initOverrides);
    }

    /**
     * Download all documents as ZIP
     */
    async downloadAllUniversalDocumentsRaw(requestParameters: DownloadAllUniversalDocumentsRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.entityType === null || requestParameters.entityType === undefined) {
            throw new runtime.RequiredError('entityType','Required parameter requestParameters.entityType was null or undefined when calling downloadAllUniversalDocuments.');
        }

        const queryParameters: any = {};

        if (requestParameters.entityType !== undefined) {
            queryParameters['entityType'] = requestParameters.entityType;
        }

        if (requestParameters.entityId !== undefined) {
            queryParameters['entityId'] = requestParameters.entityId;
        }

        if (requestParameters.entityRef !== undefined) {
            queryParameters['entityRef'] = requestParameters.entityRef;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/documents/download`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Download all documents as ZIP
     */
    async downloadAllUniversalDocuments(requestParameters: DownloadAllUniversalDocumentsRequest, initOverrides?: RequestInit): Promise<DownloadAllUniversalDocumentsResponse> {
        const response = await this.downloadAllUniversalDocumentsRaw(requestParameters, initOverrides);
        return {
          headers: response.raw.headers,
          body: await response.value(),
        };
    }

    /**
     * Download document
     */
    async downloadUniversalDocumentRaw(requestParameters: DownloadUniversalDocumentRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.documentId === null || requestParameters.documentId === undefined) {
            throw new runtime.RequiredError('documentId','Required parameter requestParameters.documentId was null or undefined when calling downloadUniversalDocument.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/documents/{documentId}`.replace(`{${"documentId"}}`, encodeURIComponent(String(requestParameters.documentId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Download document
     */
    async downloadUniversalDocument(requestParameters: DownloadUniversalDocumentRequest, initOverrides?: RequestInit): Promise<DownloadUniversalDocumentResponse> {
        const response = await this.downloadUniversalDocumentRaw(requestParameters, initOverrides);
        return {
          headers: response.raw.headers,
          body: await response.value(),
        };
    }

    /**
     * Fetches all universal documents
     */
    async findDocumentsRaw(requestParameters: FindDocumentsRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<InternalApiUniversalDocumentsList>>> {
        if (requestParameters.entityTypes === null || requestParameters.entityTypes === undefined) {
            throw new runtime.RequiredError('entityTypes','Required parameter requestParameters.entityTypes was null or undefined when calling findDocuments.');
        }

        const queryParameters: any = {};

        if (requestParameters.entityTypes) {
            queryParameters['entityTypes'] = requestParameters.entityTypes;
        }

        if (requestParameters.entityIds) {
            queryParameters['entityIds'] = requestParameters.entityIds;
        }

        if (requestParameters.entityRefs) {
            queryParameters['entityRefs'] = requestParameters.entityRefs;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/documents`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(InternalApiUniversalDocumentsListFromJSON));
    }

    /**
     * Fetches all universal documents
     */
    async findDocuments(requestParameters: FindDocumentsRequest, initOverrides?: RequestInit): Promise<Array<InternalApiUniversalDocumentsList>> {
        const response = await this.findDocumentsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Search documents for a single entity with pagination
     */
    async searchDocumentsRaw(requestParameters: SearchDocumentsRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InternalDocumentsPage>> {
        if (requestParameters.entityType === null || requestParameters.entityType === undefined) {
            throw new runtime.RequiredError('entityType','Required parameter requestParameters.entityType was null or undefined when calling searchDocuments.');
        }

        if (requestParameters.page === null || requestParameters.page === undefined) {
            throw new runtime.RequiredError('page','Required parameter requestParameters.page was null or undefined when calling searchDocuments.');
        }

        if (requestParameters.size === null || requestParameters.size === undefined) {
            throw new runtime.RequiredError('size','Required parameter requestParameters.size was null or undefined when calling searchDocuments.');
        }

        const queryParameters: any = {};

        if (requestParameters.entityType !== undefined) {
            queryParameters['entityType'] = requestParameters.entityType;
        }

        if (requestParameters.entityId !== undefined) {
            queryParameters['entityId'] = requestParameters.entityId;
        }

        if (requestParameters.entityRef !== undefined) {
            queryParameters['entityRef'] = requestParameters.entityRef;
        }

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.size !== undefined) {
            queryParameters['size'] = requestParameters.size;
        }

        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/documents/search`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalDocumentsPageFromJSON(jsonValue));
    }

    /**
     * Search documents for a single entity with pagination
     */
    async searchDocuments(requestParameters: SearchDocumentsRequest, initOverrides?: RequestInit): Promise<InternalDocumentsPage> {
        const response = await this.searchDocumentsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Uploads new universal documents
     */
    async uploadDocumentsRaw(requestParameters: UploadDocumentsRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InternalApiDocument>> {
        if (requestParameters.entityType === null || requestParameters.entityType === undefined) {
            throw new runtime.RequiredError('entityType','Required parameter requestParameters.entityType was null or undefined when calling uploadDocuments.');
        }

        if (requestParameters.file === null || requestParameters.file === undefined) {
            throw new runtime.RequiredError('file','Required parameter requestParameters.file was null or undefined when calling uploadDocuments.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters.entityType !== undefined) {
            formParams.append('entityType', requestParameters.entityType as any);
        }

        if (requestParameters.entityId !== undefined) {
            formParams.append('entityId', requestParameters.entityId as any);
        }

        if (requestParameters.entityRef !== undefined) {
            formParams.append('entityRef', requestParameters.entityRef as any);
        }

        if (requestParameters.file !== undefined) {
            formParams.append('file', requestParameters.file as any);
        }

        const response = await this.request({
            path: `/v1/documents`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalApiDocumentFromJSON(jsonValue));
    }

    /**
     * Uploads new universal documents
     */
    async uploadDocuments(requestParameters: UploadDocumentsRequest, initOverrides?: RequestInit): Promise<InternalApiDocument> {
        const response = await this.uploadDocumentsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
